export * from './stateFromElement';


//////////////////
// WEBPACK FOOTER
// ../draft-js-import-element/esm/main.js
// module id = 1033
// module chunks = 25